import { http } from "../../utils/config";

const collectionCategoryAPI = {
  // Get all categories with pagination and search
  getCategories: (params = {}) => {
    return http.get("/api/v1/collection-categories", { params });
  },

  // Get all active categories for dropdown
  getAllCategories: (params = {}) => {
    return http.get("/api/v1/public/collection-categories/all", { params });
  },

  // Get category by ID
  getCategoryById: (id) => {
    return http.get(`/api/v1/collection-categories/${id}`);
  },

  // Create new category
  createCategory: (categoryData) => {
    return http.post('/api/v1/collection-categories', categoryData);
  },

  // Update category
  updateCategory: (id, categoryData) => {
    return http.put(`/api/v1/collection-categories/${id}`, categoryData);
  },

  // Delete category
  deleteCategory: (id) => {
    return http.delete(`/api/v1/collection-categories/${id}`);
  },

  // Toggle category status
  toggleCategoryStatus: (id, status) => {
    return http.post(`/api/v1/collection-categories/${id}/status`, {
      status: status
    });
  },
};

// Helper functions for handling API responses
export const collectionCategoryHelpers = {
  // Extract category data from API response
  extractCategoryData: (response) => {
    if (response.data && response.data.success) {
      return response.data.data;
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },

  // Extract paginated category list from API response
  extractCategoryList: (response) => {
    if (response.data && response.data.success) {
      const data = response.data.data;
      return {
        categories: data.data || [],
        pagination: {
          current: data.current_page,
          pageSize: data.per_page,
          total: data.total,
          from: data.from,
          to: data.to,
          lastPage: data.last_page,
        }
      };
    }
    throw new Error(response.data?.message || 'Unknown error occurred');
  },
};

// Standard error handling wrapper
export const withErrorHandling = (apiFunction) => {
  return async (...args) => {
    try {
      const response = await apiFunction(...args);
      return response;
    } catch (error) {
      console.error('API Error:', error);

      if (error.response) {
        const { status, data } = error.response;
        switch (status) {
          case 400:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 401:
            throw new Error('Bạn cần đăng nhập để thực hiện thao tác này');
          case 403:
            throw new Error('Bạn không có quyền thực hiện thao tác này');
          case 404:
            throw new Error('Không tìm thấy loại phí');
          case 422:
            throw new Error(data.message || 'Dữ liệu không hợp lệ');
          case 500:
            throw new Error(data.message || "Lỗi server, vui lòng thử lại sau");
          default:
            throw new Error(data.message || 'Đã có lỗi xảy ra');
        }
      } else if (error.request) {
        throw new Error('Không thể kết nối đến server');
      } else {
        throw new Error(error.message || 'Đã có lỗi xảy ra');
      }
    }
  };
};

// Wrapped API functions with error handling
export const collectionCategoryAPIWithErrorHandling = {
  getCategories: withErrorHandling(collectionCategoryAPI.getCategories),
  getAllCategories: withErrorHandling(collectionCategoryAPI.getAllCategories),
  getCategoryById: withErrorHandling(collectionCategoryAPI.getCategoryById),
  createCategory: withErrorHandling(collectionCategoryAPI.createCategory),
  updateCategory: withErrorHandling(collectionCategoryAPI.updateCategory),
  deleteCategory: withErrorHandling(collectionCategoryAPI.deleteCategory),
  toggleCategoryStatus: withErrorHandling(collectionCategoryAPI.toggleCategoryStatus),
};

export default collectionCategoryAPI;
